import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sba-contaction-legend',
  templateUrl: './contaction-legend.component.html',
  styleUrls: ['./contaction-legend.component.scss']
})
export class ContactionLegendComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
